module.exports = __webpack_public_path__ + "images/upload_document.png";